import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isMultiLayer } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidImpedance = (values: EstimateValues, impedance?: string) => {
  switch (impedance) {
    case ESTIMATE_CONSTANT.特性インピーダンスコントロール.なし.value:
      return true
    case ESTIMATE_CONSTANT.特性インピーダンスコントロール["差動（2種、最小75Ωまで）"].value:
    case ESTIMATE_CONSTANT.特性インピーダンスコントロール["シングルエンド（2種）"].value:
    case ESTIMATE_CONSTANT.特性インピーダンスコントロール["シングルエンド（1種）+ 差動（1種、最小75Ωまで）"].value:
      return isMultiLayer(values)
    default:
      return false
  }
}

export default isValidImpedance
